module.exports = __webpack_public_path__ + "fonts/TTNormsPro-LightItalic.b86a3ebf.eot";